var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#E1E1E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 12.5L18.7071 17.2929C18.3166 17.6834 18.3166 18.3166 18.7071 18.7071L23.5 23.5",
    stroke: "#5E696D",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12.5L13.2071 17.2929C12.8166 17.6834 12.8166 18.3166 13.2071 18.7071L18 23.5",
    stroke: "#5E696D",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrowIcon);
export default __webpack_public_path__ + "static/media/doubleArrowIcon.02cb842252c86ac09e2bdc473347fd6f.svg";
export { ForwardRef as ReactComponent };